import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=5ea20ff2&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea20ff2')) {
      api.createRecord('5ea20ff2', component.options)
    } else {
      api.reload('5ea20ff2', component.options)
    }
    module.hot.accept("./RegistrationForm.vue?vue&type=template&id=5ea20ff2&", function () {
      api.rerender('5ea20ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/betsur/modules/components/signIn/RegistrationForm.vue"
export default component.exports